/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable prettier/prettier */

export interface FetchEventDetailsOptions {
  locationFilter?: string;
  postalCodeFilter?: string;
  rangeFilter?: string;
  datesFilter?: string[];
  sortBy?: string;
}

export interface IEpiProps {
  // Program Step
  selectProgramStepTitle: string;
  selectProgramStepDescription: string;
  viewLabelFirstTimeCertificationVsRenewals: string;
  firstTimeCertificationToggleText: string;
  renewalsToggleText: string;
  showAllProgramsCTAText: string;
  programStepValidationMessage: string
  showingNumberOfProgramsText: string
  directDeliveryToggleText: string

  // Program Step Filters
  industryFilterLabel: string
  programFormatFilterLabel: string
  trainingTypeFilterLabel: string
  applyFiltersButtonTextPrograms: string
  clearFiltersButtonText: string
  noFilterResultsCtaButton: {
    text?: string
    href?: string
    target?: string
    title?: string
  } | null
  noFilterResultsMessage: string
  hideAllProgramFilters: boolean
  hideIndustryFilter: boolean
  hideProgramFormatFilter: boolean
  hideTrainingTypeFilter: boolean

  // Breadcrumbs
  programStepBreadcrumbText: string;
  dateAndTimeStepBreadcrumbText: string;
  attendeesStepBreadcrumbText: string;
  reviewStepBreadcrumbText: string;
  backToProgramSelectionCTAText: string;
  backToAddOnSelectionCTAText: string;
  backToDateAndTimeCTAText: string;
  backToAttendeesCTAText: string;

  // Program Summary
  programSummaryHeader: string;
  programSummaryCTAText: string;
  shareSelectionsCtaTextProgramSummary: string;
  noSelectionsMessageProgramSummary: string;
  programTotalLabelProgramSummary: string;
  attendeeLabelProgramSummary: string;
  multipleAttendeesLabelProgramSummary: string;

  // Program Card
  selectButtonText: string;
  selectedButtonText: string;
  costPerAttendeeLabelText: string;
  programIncludesHeaderText: string;
  programDetailsHeaderText: string;
  mainFeaturesHeaderText: string;
  additionalFeaturesHeaderText: string;
  checkRenewalEligibilityCtaText: string

  // Add On Program Step
  addOnProgramStepTitle: string;
  addOnProgramStepDescription: string;
  addOnDetailsHeaderText: string;

  // Date Time Event Steps
  selectDateAndTimeStepSpecialtyProgramTitle: string;
  selectDateAndTimeStepSpecialtyProgramDescription: string;
  selectDateAndTimeStepSpecialtyProgramValidationMessage: string;
  noDateTimeEventsMessage: string;
  selectDateAndTimeStepAddOnProgramTitle: string
  selectDateAndTimeStepAddOnProgramDescription: string
  selectDateAndTimeStepAddOnProgramValidationMessage: string
  applyFiltersButtonText: string
  sortResultsByText: string
  sortByDateText: string
  sortByLocationText: string
  noEventsMatchFiltersMessage: string
  noFilterResultsCtaButtonDateTimeStep: {
    text?: string
    href?: string
    target?: string
    title?: string
  } | null
  resetFiltersCtaTextDateTimeStep: string
  monthYearFilterHeader: string
  locationFilterHeader: string
  locationInputLabel: string
  locationInputPlaceholder: string
  cityStateInputLabel?: string
  cityStateInputPlaceholder?: string
  postalCodeInputLabel?: string
  postalCodeInputPlaceholder?: string
  distanceFromLocationText: string
  distanceSelectPlaceholder: string
  showAllProgramsCtaTextDateTimeSteps: string

  // Date Time Card
  costPerAttendeeLabelDateTimeCard: string;
  waitlistMessageHeadingDateTimeCard: string;
  waitlistMessageDateTimeCard: string;
  virtualEventMessageDateTimeCard: string;
  virtualLocationTextDateTimeCard: string;
  productBasedCardTitleFormat: string;

  //Review Step
  reviewStepHeader: string
  editSelectionCtaText: string
  attendeesHeadingReview: string
  addToCartCtaText: string
  addToCartErrorMessage: string
  addToCartErrorMessageSomeAttendeesIneligible: string
  callMessageReviewStep: string

  //Renewal Eligibility
  checkEligibilityCtaText: string
  checkEligibilityCtaTextAdditionalAttendee: string
  checkingEligibilityCtaText: string
  eligibleMessage: string //EMAIL should be replaced with attendee's email
  notEligibleMessage: string //EMAIL should be replaced with attendee's email
  eligibilityCheckErrorMessage: string

  //Share Selections
  shareSelectionsModalHeading: string
  appliedFiltersHeading: string
  generatingLinkMessage: string
  generatingLinkErrorMessage: string
  copyLinkCtaText: string
  linkCopiedCtaText: string
  failedToCopyLinkMessage: string

  //Attendees Step
  attendeesStepTitle: string
  attendeesStepDescription: string
  addAttendeeButtonText: string
  removeAttendeeButtonText: string
  attendeeFormTitleFormat: string
  maxAttendeesMessage: string
  attendeesStepValidationMessage: string
  firstNameLabel: string
  lastNameLabel: string
  workEmailLabel: string
  titleLabel: string
  fieldRequirementText: string
  firstNamePlaceholder: string
  lastNamePlaceholder: string
  emailPlaceholder: string
  titlePlaceholder: string
  fieldRequiredMessage: string
  missingRequiredFieldsSummaryMessage: string
  fieldInvalidMessage: string
  emailsInvalidSummaryMessage: string
  attendeeNotEligibleFormat: string
  attendeesNotEligibleForRenewalSummaryMessage: string
  duplicateEmailFieldErrorMessage: string
  duplicateEmailSummaryErrorMessage: string

  //Compare Tool
  showCompareProgramsCta: boolean
  compareProgramsCtaText: string
  compareProgramsModalHeadingText: string
  compareProgramsModalDescription: string
  compareProgramsAddProgramCtaText: string
  compareProgramsResetProgramsCtaText: string

  //Header
  headerLogoLink: {
    text?: string
    href?: string
    target?: string
    title?: string
  } | null
}

export interface IEventRegistrationRefreshModel {
  culture: string;
  marketId: string;
  distanceUnit: 'mi' | 'km' | null;
  distanceUnitLabel: string | null;
  selectedLanguage: string;
  showPrice: boolean;
  currency: string;
  showConference: boolean;
  specialtyPrograms: ISpecialtyProgram[];
}

export interface IProgramBase {
  programCode: string;
  programPrice: number;
  programName: string;
  programDetails: string;
  imageUrl: string;
  programImageAlternateText: string;
}

// Interface for add-on programs
export interface IAddOnProgram extends IProgramBase {
  // Inherits all properties from ProgramBase
  programChips: string[];
  disableDateTimeSelection: boolean;
  programSku: string;
  productCardTitle: string;
  detailsDescription: string;
  costPerAttendeeFormatText: string;
}

// Interface for specialty programs
export interface ISpecialtyProgram extends IProgramBase {
  isRenewal: boolean;
  isDirectDelivery: boolean;
  programDetailsLeft: string;
  programDetailsRight: string;
  showProgramDetailsOutsideAccordion: boolean; //When true, the program details left and right content will not show, only the main program details rich text. This will show directly on the card, not on an accordion.
  industries: string[];
  programFormats: string[];
  trainingTypes: string[];
  mainFeatures: string[];
  additionalFeatures: string[];
  dateTimeStepIntroMessage?: string;
  addOnPrograms: IAddOnProgram[];
  xYearCertification: number; // Added for X-Year Certification
}

export interface IEventRegAppProps {
  epiProps: IEpiProps
  eventRegistrationRefreshModel: IEventRegistrationRefreshModel
}

export interface IAttendee {
  firstName: string
  lastName: string
  email: string
  title: string
  isEligible?: boolean
  eligibilityChecked?: boolean
}

export interface IUserSelections {
  //Use this to track the user's chosen specialty, add-on, date/time, attendees (both in the program summary as user makes selections, and global state as user confirms selections)
  userProgramSelection: IUserProgramSelection
  userAddOnProgramSelections: IUserProgramSelection[]
  userProgramDateTimeSelection: IDateTimeEvent
  userAddOnProgramDateTimeSelection: IDateTimeEvent
  attendees: IAttendee[]
  // Filters for date/time steps
  filters?: {
    /** Combined "City, State" or zip/postal value from older share links.
     * splitLocationInput() maps this onto cityState/postalCode. */
    locationInput?: string
    /** "City, State"/"City, Province" text, typed or chosen from the typeahead. */
    cityState?: string
    /** Zip (US) or postal code (Canada). Combined with cityState when both are set. */
    postalCode?: string
    rangeInput?: string
    selectedDates?: string[]
    sortByDate?: boolean
  }
}

export interface ISharedData {
  sharedUserSelections: IUserSelections;
  sharedCurrentStep: string;
}

export interface IUserProgramSelection {
  programName: string
  programCode: string
  isRenewal: boolean
  isDirectDelivery: boolean
  disableDateTimeSelection?: boolean
  programSku?: string
}

export interface IDateTimeEvent {
  culture: string;
  eventDates: string;
  eventNumber: string;
  facility: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  country: string;
  zip: string;
  timeZone: string;
  spokenLanguage: string;
  seatSku: string;
  qualification: string;
  isVirtual: boolean;
  isBlended: boolean;
  isFull: boolean;
  isFuture: boolean;
  days: string[];
  price: number;
  startDate: string; // ISO date string format
  endDate: string;   // ISO date string format
}

export interface IinitialState {
  epiProps: IEpiProps
  eventRegistrationRefreshModel: IEventRegistrationRefreshModel
  currentStep: string
  visitedSteps: string[]
  hideAttendeesStep: boolean
  userSelections: IUserSelections
  showOnlySharedProgramDateTimeSelection: boolean
  showOnlySharedAddOnProgramDateTimeSelection: boolean
  sharedProgramDateTimeEvent?: IDateTimeEvent | null
  sharedAddOnProgramDateTimeEvent?: IDateTimeEvent | null
}

export class StepConstants {
  static ProgramStep: string = "Program Step";
  static AddOnsStep: string = "Add Ons Step";
  static DateTimeSpecialtyProgramStep: string = "Date and Time Step: Specialty Program";
  static DateTimeAddOnProgramStep: string = "Date and Time Step: Add On Program";
  static AttendeesStep: string = "Attendees Step";
  static ReviewStep: string = "Review Step";
}

export interface IRenewalEligibilityResponse {
  email: string;
  isEligible: boolean;
  isError: boolean;
}
